module.exports = __webpack_public_path__ + "img/mainrejected.dff6beb9.svg";